import React from "react";
import "./tool-top.styles.scss";

export const ToolTip = ({ text }) => {
  return <div className="tool-tip-container">{text}</div>;
};
